import $ from "jquery";
// eslint-disable-next-line no-unused-vars
import slick from "slick-carousel";


const homeSlider = () => {
  const init = () => {
    slider();
    sliderCards();
  };

  const slider = () => {
    const el = {
      slider: ".js-slider-image",
      sliderReview: ".js-slider-review",
      sliderCards: ".js-slider-cards",
    };

    if (!$(el.slider).length) return;

    $(function () {
      $(el.slider).on('init', function() {
        $(el.slider).find('img').addClass('show')
      });

      $(el.slider).slick({
        infinite: true,
        slidesToShow: 8,
        autoplay: true,
        dots: false,
        arrows: false,
        autoplaySpeed: 0,
        speed:2000,
        cssEase: 'linear',
        draggable: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        variableWidth: true,
      })

      $(el.sliderReview).slick({
        infinite: false,
        slidesToShow: 1.2,
        dots: false,
        arrows: false,
        draggable: true,
        variableWidth: false,
        responsive: [{
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
            infinite: true,
            dots: true,
          }
        }]
      })
    });
  };

  const sliderCards = () => {
    const el = {
      sliderCards: ".js-slider-cards",
    };

    if (!$(el.sliderCards).length) return;

    function checkSlick() {
      if ($(window).width() > 1024) {
        if ($(el.sliderCards).hasClass('slick-initialized')) {
          $(el.sliderCards).slick('unslick');
        }
      } else {
        if (!$(el.sliderCards).hasClass('slick-initialized')) {
          $(el.sliderCards).slick({
            infinite: false,
            slidesToShow: 2.2,
            dots: true,
            arrows: false,
            draggable: true,
            variableWidth: false,
            responsive: [{
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                infinite: true
              }
            }]
          })
        }
      }
    }

    checkSlick();      // Check Slick on load

    // Re-check on window resize
    $(window).on('resize',function () {
      checkSlick();
    });
  };

  init();
};

try {
  homeSlider();
} catch (error) {
  console.error("homeSlider", error);
}
